import React, { useEffect, useState } from 'react';
import { useSocket } from '../Context/SocketContext';
import { infoUser } from '../utils/auth';
import Card from '../layout/Card';

const WidgetPaiementStat = ({ status, label, click }) => {
    const { socket } = useSocket()
    const user = infoUser();
    const [result, setResult] = useState(null)
    const getStat = () => {
        console.log(socket);

        socket && socket.emit('empire_get_stat_paiement', { token: user.expecttoken }, (e) => {
            const findByStatus = e.find(el => el.status == status);
            if (findByStatus) {
                setResult(findByStatus)
            }
            console.log(e);
        })
    }
    const init = () => {
        getStat()
    }
    useEffect(() => {
        init()
    }, [socket])
    return (
        <Card>
            <button onClick={() => click && click()} className='df aic'>
                <div className='mr3 px1 py1 df aic jcc bcb jc' style={{ borderRadius: "50%" }}  >
                    <p style={{ height: "30px", width: "30px" }} className='fb df aic jcc cw'>€</p>
                </div>
                <div>
                    <p className='fl tal cw fs12'>{label}</p>
                    <p className='cw fb fs20 tal mt1'>
                        {result?.total_price}€
                    </p>
                </div>
            </button>
        </Card>
    );
};

export default WidgetPaiementStat;